module.exports = __webpack_public_path__ + "img/free-icon-like-3845853.9e9a550f.png";